<template>
    <div id="ProgramList">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> PM Unit Forecast</div>
                    <div class="web-action-btn btn-groups text-right">
                        <!-- Button for Clear Cache
                        <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data> -->
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                            <i class="fp-export"></i> Export
                        </a>
                    </div>
                    <!-- <router-link v-if="canAddProgram" class="btn btn-primary pull-right" v-bind:to="{name: 'ProgramCreate'}" > <i class="fp-add"> </i> Add</router-link> -->
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content program-list">
                        <data-table-filter-config :moduleName="'PMUnitForecastList'" ref="filterComponent" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <div class="data-table bg-white overflow-hidden">
                          <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                          <section class="data-table bg-white">
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange" :moduleName="'PMUnitForecastList'" :position="'top'">
                                  </custom-pagination>

                                  <vue-good-table
                                      ref="listPMUnitForecastTable"
                                      mode="remote"
                                      title="Program"
                                      @on-page-change="onPageChange"
                                      @on-sort-change="onSortChange"
                                      @on-column-filter="onColumnFilter"
                                      @on-per-page-change="onPerPageChange"
                                      @on-select-all="onSelectAll"
                                      @on-selected-rows-change="selectionChanged"
                                      :totalRows="totalRecords"
                                      :columns="userColumns"
                                      :rows="rows"
                                      :pagination-options="{
                                          enabled: false,
                                          position: 'both',
                                          perPage: perPage,
                                          perPageDropdown:dropDownPerPage,
                                          dropdownAllowAll: false,
                                      }"
                                      :select-options="{
                                          enabled: true,
                                          selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                          selectionInfoClass: 'custom-class',
                                          selectionText: 'rows selected',
                                          clearSelectionText: 'clear',
                                      }"
                                      :search-options="{
                                      enabled: false,
                                      }">

                                      <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                          <div :key="key">
                                              <!-- <div v-if="props.column.field == 'action'">
                                                  <template v-if="canUpdateProgram">
                                                      <router-link title="Edit Program" class="fp-edit mr-3" v-bind:to="{name: 'ProgramEdit',params:{id:props.row.id}}"></router-link>
                                                  </template>
                                                  <router-link title="Activity" class="fp-contracts" v-bind:to="{name: 'ProgramActivityCreate',params:{id:props.row.id}}"></router-link>
                                              </div>
                                              <div v-if="props.column.field == 'name'">
                                                      <router-link title="View Program Asset" class="color-blue" v-bind:to="{name: 'ProgramAssetMapperList',params:{id:props.row.id}}">{{props.row.name}}</router-link>
                                              </div> -->
                                              <div v-if="props.column.field == 'cust_code'">
                                                  <router-link v-if="canViewCustomer" title="View Customer" class="color-blue" v-bind:key="'action_view' + key" v-bind:to="{name: 'CustomerView',params:{id:props.row.cust_id}}" target="_blank">{{props.row.cust_code}}</router-link>
                                              </div>
                                              <div v-else-if="props.column.field == 'cust_name'">
                                                  <router-link v-if="canViewCustomer" title="View Customer" class="color-blue" v-bind:key="'action_view' + key" v-bind:to="{name: 'CustomerView',params:{id:props.row.cust_id}}" target="_blank">{{props.row.cust_name}}</router-link>
                                              </div>
                                              <div v-else>
                                                  {{props.formattedRow[props.column.field]}}
                                              </div>
                                          </div>
                                      </template>
                                      <div slot="selected-row-actions">
                                          <button id="createSchedule" v-on:click.prevent="createSchedule" class="btn btn-primary">Schedule</button>
                                      </div>
                                  </vue-good-table>
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange">
                                  </custom-pagination>
                          </section>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";
import EventBus from "./../event-bus";
import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';

    export default {
        name: "PMUnitForecastList",
        metaInfo() {
            return {title: "PM Unit Forecast List | " +process.env.COPYRIGHT_NAME}
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                // {
                //     label: 'Actions',
                //     field: 'action',
                //     hidden:false,
                //     sortable: false,
                // },
                {
                    label: 'Unit',
                    field: 'unit_no',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                },
                {
                    label: 'Customer Unit',
                    field: 'customer_unit_no',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                },
                {
                    label: 'Schedule Date',
                    field: 'schedule_date',
                    filterable: true,
                    fpFieldType:"custom_date",
                    hidden:false,
                },
                {
                    label: 'Date In Service',
                    field: 'date_in_service',
                    filterable: true,
                    fpFieldType:"custom_date",
                    hidden:false,
                },
                {
                    label: 'PM Program',
                    field: 'name',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                },
                {
                    label: 'PM Description',
                    field: 'description',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                },
                // {
                //     label: 'PM Status',
                //     field: 'status',
                //     filterable: true,
                //     hidden:false,
                //     fpFieldType:"text",
                //     filterOptions: {
                //         enabled: false, // enable filter for this column
                //         placeholder: "Status", // placeholder for filter input
                //         filterValue: '', // initial populated value for this filter
                //         trigger: "enter" //only trigger on enter not on keyup
                //     }
                // },
                {
                    label: 'PM Due Date',
                    field: 'due_date',
                    filterable: false,
                    hidden:false,
                    fpFieldType:"date",
                    sortable:false
                },
                {
                    label: 'Last Completion Date',
                    field: 'completion_date',
                    filterable: false,
                    hidden:false,
                    fpFieldType:"date",
                    sortable:false
                },

                {
                    label: 'Last Completion Work order',
                    field: 'comp_work_order_no',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                },
                {
                    label: 'Days Due',
                    field: 'days_due',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                    sortable:true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Days Due", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['0-7','7-14','14-30','30+'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Days Overdue',
                    field: 'days_overdue',
                    filterable: true,
                    fpFieldType:"integer",
                    hidden:false,
                    sortable:true
                },
                {
                    label: 'Forecast Window (Days)',
                    field: 'days_diff',
                    filterable: false,
                    fpFieldType:"integer",
                    hidden:true,
                    fpMandatory:true,
                    sortable:false
                },

                {
                    label: 'Equipment Type',
                    field: 'truck_type',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                },
                {
                    label: 'PM Category Code',
                    field: 'category',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                },
                {
                    label: 'PM Type',
                    field: 'type',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                },
                {
                    label: 'Facility',
                    field: 'location',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                },
                {
                    label: 'Region',
                    field: 'region',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false
                },
                {
                    label: 'Customer Number',
                    field: 'cust_code',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    html:true
                },
                {
                    label: 'Customer Name',
                    field: 'cust_name',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    html:true
                },
                {
                    label: 'Pool',
                    field: 'pool',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                },
                {
                    label: 'Meter 1',
                    field: 'section_code1',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                },
                {
                    label: 'Meter 1 Desc',
                    field: 'section_name1',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                },
                {
                    label: 'Meter 1 Date',
                    field: 'reading_date1',
                    filterable: false,
                    fpFieldType:"date",
                    hidden:false,
                },
                {
                    label: 'Meter 1 Current',
                    field: 'reading1',
                    filterable: false,
                    fpFieldType:"integer",
                    type:"number",
                    hidden:false,
                },
                 {
                    label: 'Meter 1 LTD',
                    field: 'ltd_reading1',
                    filterable: false,
                    fpFieldType:"integer",
                    type:"number",
                    hidden:false,
                },
                {
                    label: 'Meter 1 UOM',
                    field: 'uom1',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                },
                {
                    label: 'Meter 2',
                    field: 'section_code2',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                },
                {
                    label: 'Meter 2 Desc',
                    field: 'section_name2',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                },
                {
                    label: 'Meter 2 Date',
                    field: 'reading_date2',
                    filterable: false,
                    fpFieldType:"date",
                    hidden:false,
                },
                {
                    label: 'Meter 2 Current',
                    field: 'reading2',
                    filterable: false,
                    fpFieldType:"integer",
                    type:"number",
                    hidden:false,
                },
                 {
                    label: 'Meter 2 LTD',
                    field: 'ltd_reading2',
                    filterable: false,
                    fpFieldType:"integer",
                    type:"number",
                    hidden:false,
                },
                {
                    label: 'Meter 2 UOM',
                    field: 'uom2',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                },
                {
                    label: 'Meter 3',
                    field: 'section_code3',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                },
                {
                    label: 'Meter 3 Desc',
                    field: 'section_name3',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                },
                {
                    label: 'Meter 3 Date',
                    field: 'reading_date3',
                    filterable: false,
                    fpFieldType:"date",
                    hidden:false,
                },
                {
                    label: 'Meter 3 Current',
                    field: 'reading3',
                    filterable: false,
                    fpFieldType:"integer",
                    type:"number",
                    hidden:false,
                },
                 {
                    label: 'Meter 3 LTD',
                    field: 'ltd_reading3',
                    filterable: false,
                    fpFieldType:"integer",
                    type:"number",
                    hidden:false,
                },
                {
                    label: 'Meter 3 UOM',
                    field: 'uom3',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                },
                {
                    label: 'Serial Number',
                    field: 'vin',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:true,
                },
                {
                    label: 'Ownership',
                    field: 'ownership',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:true,
                },
                {
                    label: 'Ownership Description',
                    field: 'own_description',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:true,
                },
                {
                    label: 'Equipment Maint Source',
                    field: 'equip_maint_src',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false,
                },
                {
                    label: 'Equipment Maint Description',
                    field: 'equip_maint_desc',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false,
                },
                {
                    label: 'Maint By Vendor Company Code',
                    field: 'maint_vendor_company_code',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false,
                },
                {
                    label: 'Maint By Vendor Code',
                    field: 'maint_vendor_code',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false,
                },
                {
                    label: 'Maint By Vendor Suffix',
                    field: 'maint_vendor_suffix',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false,
                },
                {
                    label: 'Maint By Vendor Number',
                    field: 'maint_vendor_number',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false,
                },
                {
                    label: 'Maint By Vendor Name',
                    field: 'maint_vendor_name',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false,
                },
                {
                    label: 'Maint By Facility ID Code',
                    field: 'maint_by_facility_code',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false,
                },
                {
                    label: 'Maint By Facility Name',
                    field: 'maint_by_facility_name',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false,
                },
                {
                    label: 'Facility Code',
                    field: 'facility_code',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false,
                },
                {
                    label: 'Facility Description',
                    field: 'facility_description',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false,
                },
                {
                    label: 'Region Code',
                    field: 'region_code',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false,
                },
                {
                    label: 'Region Description',
                    field: 'region_description',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false,
                },
                {
                    label: 'Agreed Date',
                    field: 'agreed_date',
                    fpFieldType:"date",
                    filterable: false,
                    hidden:false,
                    sortable:false
                },
                {
                    label: 'Current Work Order Number',
                    field: 'work_order_no',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                },
                {
                    label: 'PO Number',
                    field: 'po',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                },
                {
                    label: 'PO Vendor Name',
                    field: 'po_vendor',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                },
                 {
                    label: 'Super Equipment Type',
                    field: 'super_equip_type',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false
                },
                {
                    label: 'If Program On a WO',
                    field: 'program_wo',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "PO", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Include','Exclude'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Contract Type',
                    field: 'conType',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:true,
                },
                {
                    label: 'Schedule',
                    field: 'schedule',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "PO", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Yes','No','All'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
            ],
            rows: [],
            totalRecords: 0,
            term_value: false,
            loading:false,
            action: '',
            batchProcess:0,
            batchNum:"",
            canViewCustomer:false
            // canUpdateProgram:false,
            // canAddProgram:false,
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'pm_unit_forecast_report') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'view_customer') {
                            self.canViewCustomer = true;
                        }
                        // if (permissions[i].name == 'delete_Program') {
                        //     self.term_value = true;
                        // }
                        // if (permissions[i].name == 'add_program') {
                        //     self.canAddProgram = true;
                        //     self.canUpdateProgram = true;
                        // }
                    }
                }

            }

        },
        created: function() {
            this.serverParams.sort = {field:"unit_no",type:"desc"};
        },
        mounted: function() {
            var self = this;

            //self.loadList();
            self.getPermissions();
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listPMUnitForecastTable.unselectAllInternal();
            },
            // selectionChanged(param) {
            //     var self = this;
            //     if(param.selectedRows.length == 100) {
            //       EventBus.$emit('clear-selection', false);
            //     } else {
            //       EventBus.$emit('clear-all-flags', false);
            //     }
            //     // console.log(self.computed.selectedRows);
            //     // var rowData = self.$refs['my-table'].selectedRows;
            //     // console.log(rowData);
            // },

            loadList() {
                var self = this;
                self.loading = true;

                var selectedRows = [];
                var data = this.$refs['listPMUnitForecastTable'].selectedRows;
                for ( var i = 0; i < data.length; i++ ) {
                    selectedRows.push(this.$refs['listPMUnitForecastTable'].selectedRows[i].id)
                }

                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: this.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    action: self.action,
                    selectedAll:self.serverParams.selectedAll,
                    selectedRows:selectedRows,
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/pm-unit-forecast-report/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {

                            if ( self.action == "export" ||  self.action == "export_queue") {

                            if ( data.code == "201" ) {
                                alert(data.message);
                            } else {

                                if ( self.action == "export" ) {

                                    self.excel = data.content.web;
                                    var save = document.createElement("a");
                                    save.href = self.excel;
                                    save.download = data.content.web;
                                    save.target = "_blank";

                                    document.body.appendChild(save);
                                    save.click();
                                    document.body.removeChild(save);

                                } else {

                                    self.batchProcess = 1;
                                    self.batchNum = data.content;
                                }

                            }

                            self.action = "list";
                            // self.loadList();

                            } else {
                              self.rows = data.content.result.row;
                              self.totalRecords = data.content.totalRecords;
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'program-list')
                    }
                });
            },

            createSchedule:function(){
                var self = this;

                var selectedRows = [];
                var data = this.$refs['listPMUnitForecastTable'].selectedRows;
                var assetArr = [];
                // if (data.length && data.length > 1){
                   
                // }
                for ( var i = 0; i < data.length; i++ ) {
                    const dt = new Date();
                    var fullDate = dt.getMonth() + 1 + '/' + dt.getDate() + '/' + dt.getFullYear();
                    // if (Date.parse(data[i].due_date) < Date.parse(fullDate) && data[i].days_overdue < 1){
                    //     self.$swal('','Please select upcoming schedule','info');
                    //     return;
                    // }
                    if (assetArr.length > 0 && !assetArr.includes(data[i].unit_no)){
                        self.$swal('','Please select records with same unit','info');
                        return;
                    }
                    assetArr.push(data[i].unit_no);
                    
                    selectedRows.push(this.$refs['listPMUnitForecastTable'].selectedRows[i])
                }

                var path = self.$router.resolve({ name: 'MaintenanceSchedule', query: { data : btoa(JSON.stringify(selectedRows)) }});

                if (path != ''){
                    window.open(path.href, '_blank');
                }
                self.loadList();
            }
        }
    };
</script>




// WEBPACK FOOTER //
// src/components/reports/PMUnitForecastReport.vue